import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgReceiptFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.641 21.501H8.343c-2.658 0-4.244-1.654-4.244-4.424L4.082 4.825a1.7 1.7 0 0 1 .795-1.443 1.7 1.7 0 0 1 1.643-.096l.754.36c.326.16.704.17 1.038.032l2.15-.875a4.03 4.03 0 0 1 3.076 0l2.143.875c.335.135.714.126 1.038-.03h.001l.76-.364a1.69 1.69 0 0 1 1.643.096c.498.313.796.852.795 1.442l-.01 12.255c0 2.728-1.635 4.424-4.267 4.424m-6.47-10.947h2.89a.75.75 0 0 0 0-1.5H9.17a.75.75 0 0 0 0 1.5m0 4.395h5.658a.75.75 0 0 0 0-1.5H9.171a.75.75 0 1 0 0 1.5"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgReceiptFilled);
export default ForwardRef;
